<template>
  <div class="page-activity">
    <van-image
      width="100vw"
      height="auto"
      fit="cover"
      :src="ActivityImage9853"
    />
    <!-- <van-image
      width="100vw"
      height="auto"
      fit="cover"
      :src="ActivityImage8"
      lazy-load
    />
    <van-image
      width="100vw"
      height="auto"
      fit="cover"
      :src="ActivityImage5"
      lazy-load
    />
    <van-image
      width="100vw"
      height="auto"
      fit="cover"
      :src="ActivityImage3"
      lazy-load
    /> -->
  </div>
</template>

<script>
import { defineComponent, onMounted, reactive, ref } from "vue";
import ActivityImage9 from '@/assets/9.jpg'
import ActivityImage8 from '@/assets/8.jpg'
import ActivityImage5 from '@/assets/5.jpg'
import ActivityImage3 from '@/assets/3.jpg'
import ActivityImage9853 from '@/assets/9853.jpg'

export default defineComponent({
  name: "ActivityGraphic",

  components: {},

  setup() {


    onMounted(() => {
    });


    return {
      ActivityImage9,
      ActivityImage8,
      ActivityImage5,
      ActivityImage3,
      ActivityImage9853
    };
  },
});
</script>

<style lang="scss" scoped>
.page-activity {
  background: #e9f1f8;
  height: 100vh;
  width: 100%;
  overflow-y: scroll;
  padding: 0;
  margin: 0;
}
</style>